
import API from '@/api'

const actions = {
  getHotel({ commit }, { id, query, hotelIndex }) {
    commit('setHotelInitial')

    API.cart.getHotel(id)
      .then(({ data: { data } }) => {
        commit('updateHotel', {
          data,
          query,
          hotelIndex
        })

        commit('setLocation', {
          location: 'placeTo',
          value: {
            code: 'H',
            slug: data.id,
            name: data.name
          }
        })

        commit('setLocation', {
          location: 'cityTo',
          value: {
            slug: data.city.id,
            name: data.city.name
          }
        })

        commit('setLocation', {
          location: 'countryTo',
          value: data.country
        })
      })
      .catch(({ errors }) => {})
  },
  getHotelAccommodations({
    dispatch,
    commit,
    state,
    getters
  }, { hotelIndex, form }) {
    API.cart.getHotelsAccommodations(form)
      .then(({
        data: {
          data,
          include: { filters }
        }
      }) => {
        if (state.hotels[hotelIndex].accommodations.hasError) {
          commit('setServiceModuleErrors', {
            target: `hotels.${hotelIndex}.accommodations`,
            status: false,
            errors: []
          })
        }

        commit('setHotelAccommodations', {
          ...data,
          filters,
          hotelIndex
        })

        if (data.results.length === 0) {
          commit('updateServiceField', {
            target: `hotels.${hotelIndex}.form.meals`,
            value: []
          })

          commit('setServiceModuleErrors', {
            target: `hotels.${hotelIndex}.accommodations`,
            status: true,
            errors: ['По вашему запросу ничего не найдено, измените параметры поиска.']
          })
        } else {
          const {
            accommodationSearchId,
            id: hotelId,
            accommodationId
          } = getters.getIds.hotels[hotelIndex]

          dispatch('getServicePenaltiesForAll', {
            ids: {
              accommodationSearchId,
              hotelId,
              accommodationId,
              currency: getters.getCartPrice.currency
            },
            serviceName: 'hotels',
            serviceId: state.hotels[hotelIndex].info.id,
            apiModuleName: 'cart',
            label: 'Отель'
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `hotels.${hotelIndex}.accommodations`
        })

        commit('setServiceModuleErrors', {
          target: `hotels.${hotelIndex}.accommodations`,
          status: true,
          errors
        })
      })
  },
  getHotelTariffConditions({ commit, state }, { ids, hotelIndex }) {
    API.cart.getHotelTariffConditions(ids)
      .then(({ data: { data } }) => {
        if (state.hotels[hotelIndex].tariffConditions.hasError) {
          commit('setServiceModuleErrors', {
            target: `hotels.${hotelIndex}.tariffConditions`,
            status: false,
            errors: []
          })
        }

        commit('setHotelTariffConditions', {
          hotelIndex,
          tariffConditions: {
            ...data
          }
        })

        if (data.remarks.length === 0
            && data.importantInfo.length === 0
            && data.additionalInfo === null) {
          commit('setServiceModuleErrors', {
            target: `hotels.${hotelIndex}.tariffConditions`,
            status: true,
            errors: ['Поставщик не предоставил условия тарифа!']
          })
        }
      })
      .catch(({ data: { errors } }) => {
        commit('updateServiceModuleIsLoading', {
          status: false,
          target: `hotels.${hotelIndex}.tariffConditions`
        })

        commit('setServiceModuleErrors', {
          target: `hotels.${hotelIndex}.tariffConditions`,
          status: true,
          errors
        })
      })
  }
}

export default actions